import { type MouseEvent } from 'react'
import { BadgeInline, Ellipsis, StackRow } from '@dhl-ui/components'
import { type PageMenuItem } from './types'
import { SideMenuItem } from './SideMenuItem'

type Props = Pick<PageMenuItem, 'label' | 'badge' | 'link' | 'isDisabled' | 'isActive'> & {
  /**
   * Unique identifier
   */
  id: string

  /**
   * When our user selects a menu item
   */
  onClick: (event: MouseEvent<HTMLElement>) => void
}

export const SubMenuItem = ({ label, badge, isActive, ...rest }: Props) => (
  <SideMenuItem {...rest} isActive={isActive} isSubMenuItem>
    <StackRow sx={{ width: '100%' }}>
      <Ellipsis>{isActive ? <strong>{label}</strong> : label}</Ellipsis>
      {badge && <BadgeInline variant="standard" badgeContent={badge.count} color={badge.color} />}
    </StackRow>
  </SideMenuItem>
)
